// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/presupuestos/presupuestos.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_PRESUPUESTOS = [
  {
    id: 'id',
    label: 'ID',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Presupuesto',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  { id: 'nombre', label: 'Nombre', width: 160, sortable: true, filter: 'text', group: 'Persona' },
  {
    id: 'apellidos',
    label: 'Apellidos',
    width: 200,
    sortable: true,
    filter: 'text',
    group: 'Persona',
  },
  { id: 'dni', label: 'DNI', width: 130, sortable: true, filter: 'text', group: 'Persona' },
  { id: 'correo', label: 'Correo', width: 240, sortable: true, filter: 'text', group: 'Persona' },
  {
    id: 'estado',
    label: 'Estado',
    width: 200,
    sortable: true,
    filter: 'multi',
    group: 'Presupuesto',
  },
  {
    id: 'tipo',
    label: 'Tipo',
    width: 100,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Persona',
  },
  {
    id: 'inicio',
    label: 'Inicio del grupo',
    width: 130,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Grupo',
  },
  {
    id: 'tramo',
    label: 'Tramo',
    width: 120,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Grupo',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_PRESUPUESTOS = 'presupuestos';
